import React from "react";
import { useDispatch } from "react-redux";
import { formSet } from "../../actions/appActions";
import { initialCpdEventCategory } from "../../constants/factories";
import { AddCircle } from "@mui/icons-material";
import { Button } from "@mui/material";
import { TYPE_CPD_EVENT_CATEGORY } from "../../api/api";
import CpdEventCategoryList from "./CpdEventCategoryList";

const CpdEventCategory = () => {
  const dispatch = useDispatch();

  const handleCreate = () => {
    dispatch(formSet(TYPE_CPD_EVENT_CATEGORY, { ...initialCpdEventCategory }));
  };

  return (
    <>
      <Button
        sx={{ mt: 2, mb: 2 }}
        onClick={handleCreate}
        color="primary"
        variant="contained"
        disableElevation
        startIcon={<AddCircle />}
      >
        Vytvořit kategorii akce
      </Button>
      <CpdEventCategoryList />
    </>
  );
};

export default CpdEventCategory;
